import axios from 'axios';
import { Component } from "react";
import { baseUrl, config } from './index.js';
const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';
export default class CategoryService extends Component {
  static fetchAllCategory = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/get_product_cat?lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      config.params = '';
      config.data = data;
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static fetchTranslatedFilter = async (data) => {
    try {
      config.url = baseUrl + 'translate-filter?lang=' + localStorage.getItem('localLang')
      config.method = 'get';
      config.params = data;
      config.data = '';
      const response = await axios(config);
      return response.data ? response.data.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static addCategory = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/create_product_cat?lang=' + localStorage.getItem('localLang')
      config.method = 'post';
      config.params = '';
      config.data = data;
      config.headers.Authorization = 'Bearer ' + (userData ? userData?.token : '');
      const response = await axios(config);
      return response ? response : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
      return response ? response : [];
    }
  };

  static getCategoryStats = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/cat_stats?lang=' + localStorage.getItem('localLang')
      config.method = 'get';
      config.params = '';
      config.data = '';
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };
}